import '../Tutorial.css';

import {useActions} from '../../../hooks/useActions';
import {useTypedSelector} from '../../../hooks/useTypedSelector';
import React, {useState} from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T80BattleFinish() {

    const {tutorial} = useTypedSelector(state => state.auth);
    const {setTutorial} = useActions();

    const [showNext, setShowNext] = useState(false);
    const atEnd = () => {
        setShowNext(true);
    }

    /*
    useEffect(() => {
      UserService.sendEvent('BattleFinish80');
    }, []);
     */

    console.log(tutorial);

    const text = 'Continue playing on your own. Win as quickly as possible, and we will move forward.';

    return (
        <div>
            <div className='SpellTarget75All'></div>
            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialMiddleContainer80'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start().callFunction(atEnd);
                    }}
                /></div>
                {(showNext) ?
                    <div className={'tutorialButton defaultButtonAnimation'} onClick={() => {
                        tutorial.isActive = false;
                        setTutorial(tutorial);
                    }}>
                    </div>
                    : <div className={'tutorialButtonPlaceholder'}></div>
                }
            </div>

        </div>

    );
}

export default T80BattleFinish;
